import type { FC } from 'react'
import { ShopModel } from '~/models'

type OverviewProps = {
  shop: ShopModel
}

export const Overview: FC<OverviewProps> = ({ shop }) => {

  return (
    <>
      <h2 className="text-xl md:text-2xl">{shop.name}</h2>
      <p className="mt-6 text-sm whitespace-pre-wrap">{shop.description}</p>
      <div className="flex gap-1">
        {shop.contact.website?.url && (
          <a className="mt-4" href={shop.contact.website.url} target="_blank" rel="noopener noreferrer">
            <img src="/images/svg/icon/website.svg" />
          </a>
        )}
        {shop.contact.facebook?.url && (
          <a className="mt-4" href={shop.contact.facebook.url} target="_blank" rel="noopener noreferrer">
            <img src="/images/svg/icon/facebook.svg" />
          </a>
        )}
        {shop.contact.twitter?.url && (
          <a className="mt-4" href={shop.contact.twitter.url} target="_blank" rel="noopener noreferrer">
            <img src="/images/svg/icon/twitter.svg" />
          </a>
        )}
        {shop.contact.instagram?.url && (
          <a className="mt-4" href={shop.contact.instagram.url} target="_blank" rel="noopener noreferrer">
            <img src="/images/svg/icon/instagram.svg" />
          </a>
        )}

      </div>
    </>
  )
}
